import styled from 'styled-components';
import { Table as GlobalTable } from 'styles/global';
import { ButtonBase } from 'components/Button/styles';

export const Container = styled.div`
  /* background: ${props => props.theme.cardBackgroud}; */
  width: -webkit-fill-available;
  width: -moz-available;
  display: flex;
  flex-direction: column;
  height: 100%;

  >nav{
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    padding-bottom: 10px;
    >button{
      width: 15rem;
      caret-color: transparent;
      svg{
        margin-right: 10px;
      }
    }
    >div{
      width: 15rem;
    }
  }
`;

export const Table = styled(GlobalTable)`
  th {
    &:first-of-type {
      width: 70px;
    }
    &:nth-of-type(3) {
      text-align: center;
      width: 150px;
    }
    &:nth-of-type(4) {
      text-align: center;
      width: 150px;
    }
    &:nth-of-type(5) {
      text-align: center;
      width: 150px;
    }
    &:nth-of-type(6) {
      text-align: center;
      width: 230px;
    }
    &:nth-of-type(7) {
      text-align: center;
      width: 50px;
    }
    &:last-of-type {
      text-align: center;
      width: 65px;
    }
  }
  td {
    &:nth-of-type(6) {
      text-align: center;
    }
    &:nth-of-type(5) {
      justify-items: center;
      padding: 0;
      div {
        min-width: 135px;
        margin-right: 0;
      }
    }
  }
`;
